var map = {
	"./FetchAdapter.js": 37942,
	"./TestCases/bob_basic.js": 11845,
	"./TestCases/bob_classic.js": 64387,
	"./TestCases/bob_hold.js": 80162,
	"./TestCases/bob_life.js": 46361,
	"./TestCases/bob_noChild.js": 64368,
	"./TestCases/bob_noSpouse.js": 27171,
	"./TestCases/bob_spouse.js": 96808,
	"./TestCases/bob_zero.js": 42569,
	"./TestCases/casper_csr.js": 53664,
	"./TestCases/dave_dataless.js": 54445,
	"./TestCases/homeless_howard.js": 44367,
	"./TestCases/louis_grand.js": 27634,
	"./TestCases/restricted_bob.js": 73110,
	"./TestCases/tatum_stepup.js": 32376,
	"./TestCases/usher_unauthenticated.js": 67273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52499;